import { HttpClient } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SwUpdate } from '@angular/service-worker';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';


import { AlertService } from './shared/services/alert.service';
import { UserModel, JwTokenModel } from './core/api/models';
import { environment } from '../environments/environment';
import { MiniProfilerService } from './core/services/mini-profiler.service';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from './main';
import { ClientService } from "./clients";
import { Utils } from '../app/core/utils';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  standalone: false
})
export class AppComponent implements OnInit {
  private readonly document = inject(DOCUMENT);
  private subscription!: Subscription;
  private tokenRefreshInterval?: ReturnType<typeof setInterval>;
  message: any = null;

  pageTitle: string | null = null;

  constructor(private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private profiler: MiniProfilerService,
    private authService: AuthService,
    private clientService: ClientService) {

    console.debug('AppComponent.constructor');


    if (this.authService.isSignedIn()) {
      this.clientService.getActiveClients().subscribe(clients => { });
    }


  }

  ngOnInit() {
   // this.startTokenRefresh();

    if (!environment.production)
      this.profiler.init();

    this.subscription = this.alertService.getMessage().subscribe(message => {
      this.message = message;
    });



    this.router.events.pipe(
      filter((event): event is NavigationError => event instanceof NavigationError)
    ).subscribe((event: NavigationError) => {
      console.error(event.error);
      this.router.navigate(['/error'], {
        queryParams: { errorMessage: event.error?.message }
      });
    });
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        let urlTree = this.router.parseUrl(event.urlAfterRedirects);
        let parameters = JSON.stringify(urlTree.queryParams);
        urlTree.queryParams = {};
        let cleanUrl = urlTree.toString();    
        (window as any).NavigationRouterState = 'NavigationEnd: ' + cleanUrl;
      } else if (event instanceof NavigationStart) {
        (window as any).NavigationRouterState = 'NavigationStart'; 
        if (!environment.production) {
          this.profiler.clear();
        }
      }
      else if (event instanceof NavigationCancel) {
        (window as any).NavigationRouterState = 'NavigationCancel';
      }
      else if (event instanceof NavigationError) {
        (window as any).NavigationRouterState = 'NavigationError';
      }
      console.debug((window as any).NavigationRouterState);
    });





    
  }

  ngAfterViewInit(): void {
    // External fonts and logos must not keep the startup overlay over rendered forms.
    this.document.getElementById('appStartupLoading')?.remove();
    console.debug('AppComponent.AfterViewInit');


  }

  private startTokenRefresh() {
    this.tokenRefreshInterval = setInterval(() => {
      // if (this.authService.isSignedIn()) {
      //   this.authService.getTokenInfo().forEach(token => {
      //     console.debug('Token proactively refreshed', token?.expires_at);
      //   });
      // }
                
      if (this.authService.isSignedIn()
        && new Date(this.authService.tokenInfo?.expires_at || 0) < Utils.addMinutes(new Date(), 4)
        && this.authService.tokenInfo?.refresh_token
        && this.authService.tokenInfo?.refresh_expires_at
        && new Date(this.authService.tokenInfo.refresh_expires_at) > new Date() )
      {
        // If we are close to the token expiration, refresh it
        const refreshingToken = localStorage.getItem('refreshingToken') == this.authService.tokenInfo?.expires_at;
        if (!refreshingToken) {
          localStorage.setItem('refreshingToken', this.authService.tokenInfo!.expires_at!);
          this.authService.getTokenInfo().forEach(token => {
            console.debug('Token Refreshed', token?.expires_at);
            localStorage.removeItem('refreshingToken');
          });
        }
      }
    }, 4 * 60 * 1000); // every 4 minutes
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    clearInterval(this.tokenRefreshInterval);
  }

  onConfirm() {
    console.debug('onConfirm');
    this.alertService.$confirm.next(true);
    this.alertService.$confirm.complete();
    this.confirmationService.close();
  }
  onReject() {
    console.debug('onReject');
    this.alertService.$confirm.next(false);
    this.alertService.$confirm.complete();
    this.confirmationService.close();
  }
  clearMessage() {
    this.confirmationService.close();
    this.messageService.clear();
    this.message = null;
  }


  activated(comp: any) {
    this.pageTitle = comp.pageTitle || null;
    if (this.pageTitle)
      document.title = `ArkMed Management - ${this.pageTitle}`;
    else
      document.title = `ArkMed Management`;
    
  }

}
